export default "__VITE_ASSET__BqsS$r_W__"